import { render, staticRenderFns } from "./KaoShiTiMu.vue?vue&type=template&id=73e5a654&scoped=true&"
import script from "./KaoShiTiMu.vue?vue&type=script&lang=js&"
export * from "./KaoShiTiMu.vue?vue&type=script&lang=js&"
import style0 from "./KaoShiTiMu.vue?vue&type=style&index=0&id=73e5a654&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "73e5a654",
  null
  
)

export default component.exports